// extracted by mini-css-extract-plugin
export default {"menu":"MainMenu_menu__UVnw0","active":"MainMenu_active__S1Sga"};